module.exports = __webpack_public_path__ + "static/3.2_tablet-cbcc4e09e13aed704908cf50b5ef8954.jpg";